/* eslint-disable */
'use strict';

window.KEY_TIMELINE_FILTERS = 'timelineFilters';

angular.module('webAgro1App').controller('TimelineCtrl', function($scope, $rootScope, $filter, filterFilter, $q, $location, $timeout,
      TimelineService, LoadingService, PeriodSelectService, MessagesService, Flash, StorageService, PluviometrosService, ColorService) {

  $scope.filterQuebra = TIMELINE_FILTRO_QUEBRA;
  $scope.filtersColors = TimelineService.getFiltersColors();
  $scope.maxFilterIndex = $scope.filtersColors.length;

  $scope.graficoHeight = 150; //escala pixels;
  $scope.graficoPadding = 5;
  var graficoHeightWithoutPadding = ($scope.graficoHeight - $scope.graficoPadding * 2).toFixed(0);
  var min = graficoHeightWithoutPadding / 100; //valor mínimo é 1%, para conseguir visualizar o tooltip

  $scope.getHeightSerie = function(value, max) {
    var result = max > 0 ? (graficoHeightWithoutPadding * value) / max : 0;

    if (result < min) {
      result = min;
    } else if (result > graficoHeightWithoutPadding){
      result = graficoHeightWithoutPadding;
    }

    return result.toFixed(0);
  };

  $scope.getScalesSerie = function(max) {
    var countScale = 4;
    max = max > 0 ? max : graficoHeightWithoutPadding;
    var taxa = Number((max / countScale).toFixed(0));
    return _.range(taxa, max, taxa).map(function(escala) {
      return {
        eixoY: $scope.getHeightSerie(escala, max),
        valor: escala
      };
    });
  };

  var resizeTimelineContainers = function() {
    $timeout(function() {
      var alturaGrafico = $('.grafico').is(':visible') ? 150 : 0;

      var alturaMaxima = $('#timeline').height();
      var alturaFiltros = $('#timeline-filters').outerHeight();
      var alturaContainer = alturaMaxima - alturaFiltros;
      $('#timeline-container').height(alturaContainer);

      var alturaTitulo = $('.title').outerHeight();
    }, 50);
  };

  $scope.isLastIndexDados = function(index) {
    return index === $scope.dadosLength - 1;
  };

  $scope.openPeriodsFilter = function(filterIndex, event) {
    preventDefault(event);
    PeriodSelectService.openPeriodSelection($scope.arrFilters[filterIndex].filters.period, $scope.arrFilters[filterIndex]);
  };

  $scope.getCheckedItems = function(arrayValues) {
    return (filterFilter(arrayValues || [], {checked: true}, true) || []).map(function(value) {
      return value.descricao;
    }).join(', ');
  };

  $scope.getEstadioRegistro = function(object) {
    return (object[Object.keys(object)[0] || []][0] || {}).estadio;
  };

  $scope.getDataEstadioRegistro = function(object) {
    return TimelineService.getSortDateObject(object)[0];
  };

  $scope.canDisplayDadosMeteorologicos = function() {
    return ($scope.arrFilters.length === 1 && Object.keys(($scope.dadosMeteorologicos || {}).dados || []).length);
  };

  $scope.isQuebraEstadio = function(quebra) {
    return quebra === TIMELINE_FILTRO_QUEBRA.estadio;
  };

  var isOperacao = function(filterIndex, tiposOperacoes) {
    var ret = false;
    var operacoes = (($scope.arrFilters[filterIndex] || {}).operacoes || []);
    for (var operacao in operacoes) {
      ret = (tiposOperacoes || []).indexOf(operacoes[operacao]) >= 0;
      if (ret) {
        break;
      }
    }
    return ret;
  };

  $scope.isOperacaoOcorrencias = function(filterIndex, operacao) {
    if (operacao) {
      return TIPOS_OPERACAO_OCORRENCIAS.indexOf(operacao) >= 0;
    }

    return isOperacao(filterIndex, TIPOS_OPERACAO_OCORRENCIAS);
  };

  $scope.isOperacaoGrupoInsumos = function(filterIndex, operacao) {
    if (operacao) {
      return TIPOS_OPERACAO_RECOMENDACAO_PULVERIZACAO.indexOf(operacao) >= 0;
    }

    return isOperacao(filterIndex, TIPOS_OPERACAO_RECOMENDACAO_PULVERIZACAO);
  };

  var genericError = function() {
    MessagesService.alert('Falha ao carregar dados, tente novamente mais tarde.');
  };

  function preventDefault(event) {
    if (event) {
      event.preventDefault();
    }
  }

  var updateSelectFilters = function(filterIndex) {
    var deferred = $q.defer();

    var arrValues = $scope.arrFilters[filterIndex];
    arrValues.loadings.selectFilters = true;

    TimelineService.getAllSelectFilters(arrValues).then(function(result) {
      arrValues.filters.glebas = result.glebas;
      arrValues.filters.culturas = result.culturas;
      arrValues.filters.operacoes = result.operacoes;
    }, genericError).finally(function() {
      arrValues.loadings.selectFilters = false;
      deferred.resolve();
    });

    return deferred.promise;
  };

  var updateFilterOcorrenciasInsumos = function(filterIndex, operacao) {
    var updateFilterOcorrencias = function() {
      if (!operacao.checked) {
        if ($scope.arrFilters[filterIndex].filters.ocorrencias[operacao.descricao]) {
          delete $scope.arrFilters[filterIndex].filters.ocorrencias[operacao.descricao];
          $scope.setOcorrencia(filterIndex);
        }
      } else {
        $scope.arrFilters[filterIndex].loadings.ocorrenciasInsumosFilter = true;
        TimelineService.getFilterOcorrencias($scope.arrFilters[filterIndex]).then(function(result) {
          var ocorrencias = result;
          if (ocorrencias[operacao.descricao]) {
            $scope.arrFilters[filterIndex].filters.ocorrencias[operacao.descricao] = ocorrencias[operacao.descricao];
          }
        }).finally(function() {
          $scope.arrFilters[filterIndex].loadings.ocorrenciasInsumosFilter = false;
        });
      }
    };

    var updateFilterInsumos = function() {
      if (!operacao.checked && !$scope.isOperacaoGrupoInsumos(filterIndex)) {
        $scope.arrFilters[filterIndex].filters.gruposInsumos = [];
        $scope.setGrupoInsumo(filterIndex);
      } else if (!$scope.arrFilters[filterIndex].filters.gruposInsumos.length) {
        $scope.arrFilters[filterIndex].loadings.ocorrenciasInsumosFilter = true;
        TimelineService.getFilterGruposInsumos($scope.arrFilters[filterIndex]).then(function(result) {
          $scope.arrFilters[filterIndex].filters.gruposInsumos = result.data || [];
        }).finally(function() {
          $scope.arrFilters[filterIndex].loadings.ocorrenciasInsumosFilter = false;
        });
      }
    };

    if (operacao) {
      var isOcorrencia = $scope.isOperacaoOcorrencias(filterIndex, operacao.id);
      var isInsumo = $scope.isOperacaoGrupoInsumos(filterIndex, operacao.id);

      if (isOcorrencia) {
        updateFilterOcorrencias();
      } else if (isInsumo) {
        updateFilterInsumos();
      }
    } else {
      $scope.arrFilters[filterIndex].filters.ocorrencias = {};
      $scope.arrFilters[filterIndex].filters.gruposInsumos = [];
      $scope.setOcorrencia(filterIndex);
      $scope.setGrupoInsumo(filterIndex);
    }
  };

  var getValuesChecked = function(values) {
    return TimelineService.getMapValuesArray(filterFilter(values, {checked: true}, true) || []);
  };

  $scope.setPropriedade = function(filterIndex, propriedade, event) {
    preventDefault(event);

    var deferred = $q.defer();
    var initialFilters = {
      cultura: $scope.arrFilters[filterIndex].cultura || {},
      operacoes: $scope.arrFilters[filterIndex].operacoes || []
    };

    initVariables(filterIndex);
    $scope.arrFilters[filterIndex].propriedade = propriedade || $rootScope.currentPropriedade;
    $scope.setPeriodo(filterIndex, $scope.filtroPeriodo[0]);
    updateSelectFilters(filterIndex).then(function() {
      var culturas = $scope.arrFilters[filterIndex].filters.culturas;
      var cultura = null;
      if ($scope.timelineFilters) {
        var gleba = filterFilter($scope.arrFilters[filterIndex].filters.glebas, {id: $scope.timelineFilters.gleba_id || null}, true)[0];
        $scope.setGleba(filterIndex, gleba);

        if ($scope.timelineFilters.safra_id) {
          var periodo = filterFilter($scope.filtroPeriodo, {id: $scope.timelineFilters.safra_id}, true)[0] || {};
          if (!periodo.id) {
            var safra = filterFilter($rootScope.safras, {id: $scope.timelineFilters.safra_id}, true)[0] || {};
            if (safra.id) {
              periodo = {
                id: 'customizado',
                dataInicial: moment(safra.data_inicial).startOf('day'),
                dataFinal: moment(safra.data_final).startOf('day'),
                descricao: 'Customizado'
              };
            }
          }

          if (periodo.id) {
            $scope.setPeriodo(filterIndex, periodo);
          }
        }

        initialFilters = {
          cultura: {id: $scope.timelineFilters.atividade_id || null},
          operacoes: [$scope.timelineFilters.operacao_id || null]
        };
      }

      cultura = filterFilter(culturas, {id: initialFilters.cultura.id || null}, true)[0];
      $scope.setCultura(filterIndex, cultura);

      if (($scope.arrFilters[filterIndex].cultura || {}).id) {
        $scope.quebra = $scope.quebra;
      }
      initialFilters.operacoes.forEach(function(operacao) {
        var oper = filterFilter($scope.arrFilters[filterIndex].filters.operacoes, {id: operacao}, true)[0];
        if (oper) {
          $scope.setOperacao(filterIndex, oper);
        }
      });
    }).finally(deferred.resolve);

    return deferred.promise;
  };

  $scope.setGleba = function(filterIndex, gleba, event) {
    preventDefault(event);
    $scope.arrFilters[filterIndex].gleba = gleba;
  };

  $scope.setOperacao = function(filterIndex, operacao, event) {
    preventDefault(event);

    if (operacao) {
      operacao.checked = !operacao.checked;
    } else {
      $scope.arrFilters[filterIndex].filters.operacoes.forEach(function(operacao) {
        operacao.checked = false;
      });
    }

    $scope.arrFilters[filterIndex].operacoes = getValuesChecked($scope.arrFilters[filterIndex].filters.operacoes);
    updateFilterOcorrenciasInsumos(filterIndex, operacao);
  };

  $scope.setOcorrencia = function(filterIndex, ocorrencia, arrayOcorrencias, event) {
    preventDefault(event);

    if (ocorrencia) {
      ocorrencia.checked = !ocorrencia.checked;
    } else {
      (arrayOcorrencias || []).forEach(function(ocorrencia) {
        ocorrencia.checked = false;
      });
    }

    $scope.arrFilters[filterIndex].ocorrencias = TimelineService.getOcorrenciasChecked($scope.arrFilters[filterIndex].filters.ocorrencias);
  };

  $scope.setGrupoInsumo = function(filterIndex, grupo, event) {
    preventDefault(event);

    if (grupo) {
      grupo.checked = !grupo.checked;
    } else {
      $scope.arrFilters[filterIndex].filters.gruposInsumos.forEach(function(grupo) {
        grupo.checked = false;
      });
    }

    $scope.arrFilters[filterIndex].gruposInsumos = getValuesChecked($scope.arrFilters[filterIndex].filters.gruposInsumos);
  };

  $scope.setCultura = function(filterIndex, cultura, event) {
    preventDefault(event);
    $scope.arrFilters[filterIndex].cultura = cultura;
    if (!cultura) {
      $scope.quebra = $scope.filterQuebra.dia;
    }
  };

  $scope.setPeriodo = function(filterIndex, periodo, event) {
    preventDefault(event);
    $scope.arrFilters[filterIndex].dataInicial = periodo.dataInicial;
    $scope.arrFilters[filterIndex].dataFinal = periodo.dataFinal;
    $scope.arrFilters[filterIndex].filters.period.periodo = periodo.descricao;
  };

  $scope.setQuebra = function(quebra) {
    if ($scope.isQuebraEstadio(quebra)) {
      var hasCulture = true;
      for (var index in $scope.arrFilters) {
        if (!($scope.arrFilters[index].cultura || {}).id) {
          hasCulture = false;
          break;
        }
      }

      if (!hasCulture) {
        MessagesService.alert('Para este tipo de visualização, deve ser selecionado a cultura.');
        return;
      }
    }
    $scope.quebra = quebra;
  };

  $scope.setPluviometro = function(pluviometro, event) {
    preventDefault(event);

    $scope.dadosMeteorologicos.selected = pluviometro;

    var selected = $scope.dadosMeteorologicos.selected;
    $scope.allPluviometros = Object.keys($scope.dadosMeteorologicos.dados).reduce(function(result, pluviometro) {
      $scope.dadosMeteorologicos.selected = pluviometro;

      if ($scope.isQuebraEstadio($scope.quebra)) {
        result[pluviometro] = TimelineService.getGraficoMeteorologicoEstadio($scope.dados, $scope.dadosMeteorologicos, $scope.arrFilters[0]);
      } else {
        result[pluviometro] = TimelineService.getGraficoMeteorologico($scope.dados, $scope.dadosMeteorologicos, $scope.arrFilters[0]);
      }

      return result;
    }, {});
    $scope.dadosMeteorologicos.selected = selected;
    if (pluviometro === 'TODOS') {
      $scope.graficoMeteorologico = $scope.allPluviometros;

      var maxSerieChuva = _.max(_.map($scope.allPluviometros, 'maxSerieChuva'));
      Object.values($scope.allPluviometros).forEach(function(pluviometro) {
        pluviometro.maxSerieChuva = maxSerieChuva;
        pluviometro.color = ColorService.getRandom();
        pluviometro.hasMany = true;
      });

      $scope.graficoMeteorologico.maxSerieChuva = maxSerieChuva;
    } else {
      $scope.graficoMeteorologico = {
        pluviometro:  $scope.allPluviometros[pluviometro],
        maxSerieChuva: ($scope.allPluviometros[pluviometro] || {}).maxSerieChuva
      };
    }
  };

  var getDados = function() {
    var setDados = function(result) {
      $scope.dados = TimelineService.getStructureValues(result);
    };

    $rootScope.timelineBackupFilters = $scope.arrFilters;
    $rootScope.quebraTimeline = $scope.quebra;

    $scope.dados = null;
    var deferred = $q.defer();
    var promises = [];

    $scope.arrFilters.map(function(filters) {
      promises.push(TimelineService.get(filters, $scope.quebra));
    });

    $q.all(promises).then(function(result) {
      $scope.quebraSelected = $scope.quebra;

      setDados(result);

      if (!Object.keys($scope.dados).length) {
        MessagesService.alert('Nenhum registro encontrado');
      }

      resizeTimelineContainers();
      deferred.resolve();
    }, function() {
      genericError();
      deferred.reject();
    });

    return deferred.promise;
  };

  $scope.getTimeline = function() {
    $scope.dados = {};
    $scope.dadosMeteorologicos = {};
    if (($scope.arrFilters[0].propriedade || {}).id && $scope.arrFilters[0].dataInicial && $scope.arrFilters[0].dataFinal) {
      LoadingService.showLoading();
      getDados().finally(LoadingService.hideLoading);
    }
  };

  $scope.addFilterSelects = function() {
    var count = $scope.arrFilters.length;
    if (count < $scope.maxFilterIndex) {
      $scope.arrFilters.push(JSON.parse(JSON.stringify($scope.arrFilters[count-1])));
      $scope.quebra = $scope.filterQuebra.dia;
      resizeTimelineContainers();
    }
  };

  $scope.deleteFilterSelects = function(index) {
    if ($scope.arrFilters.length > 1 && $scope.arrFilters[index]) {
      $scope.arrFilters.splice(index, 1);
      resizeTimelineContainers();
    }
  };

  var getFilterEmpty = function() {
    return {
      filters: {
        period: {
          eventDates: [],
          periodo: ''
        },
        ocorrencias: {},
        gruposInsumos: []
      },
      loadings: {
        selectFilters: false,
        ocorrenciasInsumosFilter: false
      }
    };
  };

  function initVariables(filterIndex) {
    if (filterIndex >= 0) {
      $scope.arrFilters[filterIndex] = getFilterEmpty();
    } else {
      $scope.arrFilters = [getFilterEmpty()];
      $scope.timelineFilters = StorageService.get(KEY_TIMELINE_FILTERS);
      StorageService.remove(KEY_TIMELINE_FILTERS);
    }
    $scope.quebra = $scope.filterQuebra.dia;
  }

  var init = function() {
    var executeGetDados = function() {
      getDados().finally(LoadingService.hideLoading);
    };

    delete $rootScope.standDetails;
    delete $rootScope.produtividadeDetails;

    LoadingService.showLoading();
    initVariables();
    $rootScope.initialize.then(function() {
      if (!$rootScope.permissions.timeline.canRead) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
        return;
      }

      $scope.filtroPeriodo = PeriodSelectService.getFilterPeriodo($scope.safras);

      if ($scope.timelineFilters || !$rootScope.timelineBackupFilters) {
        $scope.setPropriedade(0).finally(executeGetDados);
      } else {
        $scope.arrFilters = $rootScope.timelineBackupFilters;
        $scope.quebra = $rootScope.quebraTimeline;
        executeGetDados();
      }
    }, $rootScope.errorRootInitialize);
  };

  $scope.limparFiltros = function() {
    $rootScope.timelineBackupFilters = null;
    $rootScope.quebraTimeline = null;
    init();
  };

  var removerTooltips = function() {
    $('.tpd-tooltip').remove();
  };

  $scope.goToPropriedade = function(historico, filterIndex) {
    const propriedadeId = $scope.arrFilters[filterIndex].propriedade.id;
    if (historico.tipo === 'recomendacao_semeadura') {
      return '#!/recomendacoes_semeadura';
    }
    if (historico.tipo === 'tratamento_semente') {
      return `#!/propriedade?propriedade=${propriedadeId}&date=${historico.created_at}&sidebar=applications&activeApplicationsTab=ts`;
    }
    return `#!/propriedade?propriedade=${propriedadeId}&date=${historico.created_at}&activeGleba=${historico.gleba.id}&notification=${historico.tipo}`;
  };
  $scope.$on('$destroy', removerTooltips);

  init();

  $scope.$watchCollection('dados', function(newValue, oldValue) {
    if (newValue !== oldValue) {
      $scope.dadosLength = Object.keys($scope.dados || {}).length;
    }
  });

  //TO DO - Remover para directive
  // seta scroll do mouse para horizontal
  (function() {
    function scrollHorizontally(e) {
      e = window.event || e;
      var delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
      document.getElementById('timeline-container').scrollLeft -= (delta*50);
      e.preventDefault();
    }
    if (document.getElementById('timeline-container').addEventListener) {
      // IE9, Chrome, Safari, Opera
      document.getElementById('timeline-container').addEventListener('mousewheel', scrollHorizontally, false);
      // Firefox
      document.getElementById('timeline-container').addEventListener('DOMMouseScroll', scrollHorizontally, false);
    } else {
      // IE 6/7/8
      document.getElementById('timeline-container').attachEvent('onmousewheel', scrollHorizontally);
    }
  }());
});
